import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DeliveryNoteProofOfDeliveryFacade } from './delivery-note-proof-of-delivery.facade';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { switchMap } from 'rxjs/operators';
import { DeliveryNoteItemFacade } from '../delivery-note-item.facade';
import { DeliveryNoteParams } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteProofOfDeliveryGuard {
  constructor(
    private deliveryNoteProofOfDeliveryFacade: DeliveryNoteProofOfDeliveryFacade,
    private deliveryNoteItemFacade: DeliveryNoteItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.deliveryNoteItemFacade.deliveryNoteParams$.pipe(
      switchMap((params: DeliveryNoteParams) => checkStoreState(this.deliveryNoteProofOfDeliveryFacade, params)),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.deliveryNoteProofOfDeliveryFacade);
  }
}
